<template>
	<div class="modal fade" :id="modal.selector" tabindex="-1" role="dialog" aria-hidden="true">
		<div class="modal-dialog modal-lg" role="document">
			<div class="modal-content">
				<div class="modal-header">
					<div class="btn-toolbar pull-right" role="toolbar">
						<div class="btn-group" role="group" aria-label="...">
							<button type="button" class="close" data-dismiss="modal" aria-label="Close">
								<span aria-hidden="true">&times;</span>
							</button>
						</div>
					</div>
					<h4  class="modal-title">Términos y condiciones</h4>
				</div>
				<div class="modal-body">
					<loading :active="loading">
						<img :src="$env.ROOT + '/img/loading.gif'" width="55px" height="55px">
					</loading>
					<div class="row">
						<div class="col-md-12">
							<ul class="nav nav-tabs" role="tablist">
								<li role="presentation" class="active">
									<a href="#budget" role="tab" data-toggle="tab" aria-expanded="true">
										<span class="visible-xs"><i aria-hidden="true" class="fa fa-clipboard"></i></span>
										<span class="hidden-xs">Presupuesto</span>
									</a>
								</li>
								<li role="presentation">
									<a href="#order" role="tab" data-toggle="tab" aria-expanded="true">
										<span class="visible-xs"><i aria-hidden="true" class="fa fa-file-text"></i></span>
										<span class="hidden-xs">Pedido</span>
									</a>
								</li>
								<li role="presentation">
									<a href="#invoice" role="tab" data-toggle="tab" aria-expanded="true">
										<span class="visible-xs"><i aria-hidden="true" class="fa fa-clipboard"></i></span>
										<span class="hidden-xs">Factura</span>
									</a>
								</li>
								<li role="presentation">
									<a href="#agreement" role="tab" data-toggle="tab" aria-expanded="true">
										<span class="visible-xs"><i aria-hidden="true" class="fa fa-handshake-o"></i></span>
										<span class="hidden-xs">Contrato</span>
									</a>
								</li>
							</ul>
							<div class="tab-content">
								<div role="tabpanel" class="tab-pane active" id="budget">
									<div class="col-md-12">
										<div class="form-group">
											<label class="control-label">Título</label>
											<input
												v-model="terms_and_conditions.budget.title"
												type="text"
												class="form-control">
										</div>
									</div>
									<div class="col-md-12">
										<div class="form-group">
											<label class="control-label">
												Descripción
											</label>
											<quill-editor v-model="terms_and_conditions.budget.description"
												ref="descriptionEditor">
											</quill-editor>
										</div>
									</div>
									<div class="col-md-12">
										<div class="btn-group pull-right">
											<button @click="save('budget')" type="button" class="btn btn-default">
												Guardar
											</button>
										</div>
									</div>
								</div>
								<div role="tabpanel" class="tab-pane" id="order">
									<div class="col-md-12">
										<div class="form-group">
											<label class="control-label">Título</label>
											<input
												v-model="terms_and_conditions.order.title"
												type="text"
												class="form-control">
										</div>
									</div>
									<div class="col-md-12">
										<div class="form-group">
											<label class="control-label">
												Descripción
											</label>
											<quill-editor v-model="terms_and_conditions.order.description"
												ref="descriptionEditor">
											</quill-editor>
										</div>
									</div>
									<div class="col-md-12">
										<div class="btn-group pull-right">
											<button @click="save('order')" type="button" class="btn btn-default">
												Guardar
											</button>
										</div>
									</div>
								</div>
								<div role="tabpanel" class="tab-pane" id="invoice">
									<div class="col-md-12">
										<div class="form-group">
											<label class="control-label">Título</label>
											<input
												v-model="terms_and_conditions.invoice.title"
												type="text"
												class="form-control">
										</div>
									</div>
									<div class="col-md-12">
										<div class="form-group">
											<label class="control-label">
												Descripción
											</label>
											<quill-editor v-model="terms_and_conditions.invoice.description"
												ref="descriptionEditor">
											</quill-editor>
										</div>
									</div>
									<div class="col-md-12">
										<div class="btn-group pull-right">
											<button @click="save('invoice')" type="button" class="btn btn-default">
												Guardar
											</button>
										</div>
									</div>
								</div>
								<div role="tabpanel" class="tab-pane" id="agreement">
									<div class="col-md-12">
										<div class="form-group">
											<label class="control-label">Título</label>
											<input
												v-model="terms_and_conditions.agreement.title"
												type="text"
												class="form-control">
										</div>
									</div>
									<div class="col-md-12">
										<div class="form-group">
											<label class="control-label">
												Descripción
											</label>
											<quill-editor v-model="terms_and_conditions.agreement.description"
												ref="descriptionEditor">
											</quill-editor>
										</div>
									</div>
									<div class="col-md-12">
										<div class="btn-group pull-right">
											<button @click="save('agreement')" type="button" class="btn btn-default">
												Guardar
											</button>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="modal-footer">
					<button type="button" class="btn btn-default" data-dismiss="modal">Cerrar</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import swal from 'sweetalert2'
	import VueElementLoading from 'vue-element-loading'

	export default {
		props: ['user', 'isAuth'],
		components: {
			'loading': VueElementLoading,
		},
		data () {
			return {
				modal: {
					selector: 'modal-setting-terms-and-conditions'
				},
				loading: false,

				types: ['budget', 'order', 'invoice', 'agreement'],

				terms_and_conditions: {
					budget: {
						type: 'budget',
						title: null,
						description: null,
					},
					order: {
						type: 'order',
						title: null,
						description: null,
					},
					invoice: {
						type: 'invoice',
						title: null,
						description: null,
					},
					agreement: {
						type: 'agreement',
						title: null,
						description: null,
					},
				}
			}
		},
		methods: {
			open() {
				this.getData()
				var modal = $('#'+this.modal.selector)
				modal.modal('show')
			},
			close() {
				var modal = $('#'+this.modal.selector)
				modal.modal('hide')
			},
			reload() {
				this.getData()
			},
			getData() {
				var that = this
				this.types.forEach(function(type) {
					that.loading = true
					that.$http.get('admin/management/terms/conditions/get/' + type)
					.then(response => {
						that.loading = false
						if(response.body) {
							that.terms_and_conditions[type] = response.body
						}
					}).catch(function(response) {
						console.log(response)
					})
				})

			},
			save(type) {
				var term_and_condition = this.terms_and_conditions[type]
				if(term_and_condition.id) {
					this.update(type, term_and_condition)
				} else {
					this.store(type, term_and_condition)
				}
			},
			store(type, term_and_condition) {
				this.loading = true
				this.$http.post('admin/management/terms/conditions', term_and_condition)
				.then(response => {
					this.loading = false
					this.reload()
					swal({
						title: response.body.title,
						text: response.body.text,
						type: response.body.type,
					})
				}).catch(function(response) {
					console.log(response)
					this.loading = false
				})
			},
			update(type, term_and_condition) {
				this.loading = true
				this.$http.put('admin/management/terms/conditions/' + term_and_condition.id, term_and_condition)
				.then(response => {
					this.loading = false
					this.reload()
					swal({
						title: response.body.title,
						text: response.body.text,
						type: response.body.type,
					})
				}).catch(function(response) {
					console.log(response)
					this.loading = false
				})
			},
		},
	}
</script>


// WEBPACK FOOTER //
// src/components/settings/views/TermsAndConditions.vue